import { render, staticRenderFns } from "./best-available-table-row.component.vue?vue&type=template&id=10db3e0b&scoped=true"
import script from "./best-available-table-row.component.vue?vue&type=script&lang=js"
export * from "./best-available-table-row.component.vue?vue&type=script&lang=js"
import style0 from "./best-available-table-row.component.vue?vue&type=style&index=0&id=10db3e0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db3e0b",
  null
  
)

export default component.exports